import React from 'react'

import SelectInput from '../../components/form/SelectInput'
import { useI18N } from '../../../libraries/i18n/hook'
import { ContractDetails } from '../../../api/job-offers/types'

type Props = {
  onChange: (values: { contractDetails: ContractDetails[] }) => void,
  values?: string[]
  isDisabled?: boolean
}
const ContractDetailsSelectBox: React.FC<Props> = ({ onChange, values, isDisabled }) => {
  const { t } = useI18N()

  const handleChange = (contractDetails: string[]) => {
    onChange({ contractDetails: contractDetails as ContractDetails[] })
  }

  const options = [
    { label: t('jobs.internship.agreement'), value: ContractDetails.INTERNSHIP_AGREEMENT },
    { label: t('jobs.internship.curriculars'), value: ContractDetails.INTERNSHIP_CURRICULAR },
  ]

  return (
    options && (
      <SelectInput
        isDisabled={isDisabled}
        value={options?.filter(contractDetail => values?.includes(contractDetail.value.toString()))}
        name='contractDetails'
        label={t('jobs.contract.details')}
        onChange={handleChange}
        options={options}
        autoMinWidth
      />
    )
  )
}

export default ContractDetailsSelectBox
